module.exports = __webpack_public_path__ + "img/ic-bd.2a465c92.svg";